import React, { memo } from 'react'
import { Navigate, Outlet } from 'react-router-dom';
import { isProvider } from './common/authentification-functions';

type Props = {}

const ProviderGuard: React.FC<Props> = memo((props: Props) => {
    if(!isProvider()){
        return <Navigate to="/login" replace/>
    }
    
    return (
        <Outlet />
    )
})

export default ProviderGuard